module.exports = __webpack_public_path__ + "assets/img/vulnerability-show-version.8b16ce97.svg";